// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll('#privary-navigation li:has(.submenu)')
		let prevMenuItem

		menu_Items.forEach((element) => {
			// active for link generate in js
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			const newListItem = `
			<li class="privary-navigation__item primary-nav-js">
				<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">Overview</a>
			</li>`

			//Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			// active for link generate in js
			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}

			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				const submenu = e.target.nextElementSibling;
				if (submenu && submenu.classList.contains('submenu')) {
					submenu.classList.toggle('show');
				}

				if (prevMenuItem && prevMenuItem !== submenu) {
					prevMenuItem.classList.remove('show');
				}
				prevMenuItem = submenu.classList.contains('show') ? submenu : null;
			})
		})
	}


    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	document.querySelectorAll('.btn, .btn-white, .btn-alt').forEach((button)=>{
		let text = button.textContent;
		let span = document.createElement('span');
		button.innerHTML = "";
		span.textContent = text;
		button.insertAdjacentElement('afterbegin', span);
	});


	document.querySelectorAll('.js-open-menu').forEach((button)=>{
		button.addEventListener('click', ()=>{
			document.getElementById('menu-site').classList.toggle('show');
			if( !button.classList.contains('no-chage-label') ){
				button.classList.toggle('close');
				if(button.classList.contains('close')){
					button.querySelector('.label').textContent = 'Close';
				}else{
					button.querySelector('.label').textContent = 'Menu';
				}
			}
		})
	});

	//Location select
	if (document.querySelector('.js-show-booking')) {
		const button = document.querySelector('.js-show-booking');
		const targetElement = document.querySelector('#header .header__location');
	
		button.addEventListener('click', () => {
			targetElement.classList.toggle('show');
			button.classList.toggle('active-location');
			if (targetElement.classList.contains('show')) {
				button.textContent = 'Close';
			} else {
				button.textContent = 'Location';
			}
		});
	}

	if(document.querySelector('.quad-tabs')){
		let tabsQuad = document.querySelectorAll('.quad-tabs__filter li');
		let itemsTabs = document.querySelectorAll('.quad-tabs__item');
		let lastClickTab = null;

		tabsQuad.forEach((tab)=>{
			tab.addEventListener('click', ()=>{
				let dataEntry = tab.dataset.tag;
				if(lastClickTab){
					lastClickTab.classList.remove('active');
				}
				tab.classList.add('active');
				lastClickTab = tab;
				itemsTabs.forEach((item)=>{
					item.classList.toggle('hidden', item.dataset.tag != dataEntry);
				})
			})
		})
		tabsQuad[0].click();
	}

	/** ADA - Add aria-label to Footer Navigation **/
	document.addEventListener("DOMContentLoaded", function () {
		const secondaryNavFooter = document.querySelector(".footer__top #secondary-nav");

		if (secondaryNavFooter) {
			secondaryNavFooter.setAttribute("aria-label", "Secondary Footer Navigation");
		}
	});

	/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

	function updateMenuTabIndex() {
		const menu = document.querySelector('#menu-site');
		const isMenuVisible = menu && menu.classList.contains('show');
		const elements = document.querySelectorAll('#menu-site .privary-navigation__item a, #menu-site .secondary-navigation__item a');
	
		elements.forEach(element => {
			element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
		});
	}
	document.addEventListener('DOMContentLoaded', () => {
		updateMenuTabIndex();
	
		document.addEventListener('focusin', updateMenuTabIndex);
		const menu = document.querySelector('#menu-site');
		if (menu) {
			menu.addEventListener('transitionend', updateMenuTabIndex);
		}
	});
	
	document.addEventListener('DOMContentLoaded', () => {
		const navLinks = document.querySelectorAll('#privary-navigation > .privary-navigation__item > a[aria-haspopup="true"]');
		navLinks.forEach(link => {
			const submenu = link.nextElementSibling;
			if (submenu && submenu.classList.contains('privary-navigation__submenu')) {
				link.addEventListener('keydown', event => {
				if (event.key === 'Enter') {
					submenu.classList.add('show');
				}
				});
			}
		});
	});


	//accordion Functionality
	let normal_accordion = document.querySelectorAll("[data-accodion] .tab-js");
	normal_accordion.forEach( (item, i) => {
		item.addEventListener("click", (element) => {
			element.target.classList.toggle("active");
			element.target.nextElementSibling.classList.toggle("active");
		});

		if (i ==0) item.click()
	});


	const bookNowBtn = document.querySelector('#show-location-mobile');
    const dropdown = document.querySelector('.footer-dropdown__location');

    if (bookNowBtn && dropdown) {
		bookNowBtn.addEventListener('click', function (e) {
			dropdown.classList.toggle('active');
		});
		
		document.addEventListener('click', function (e) {
			if (!dropdown.contains(e.target) && !bookNowBtn.contains(e.target)) {
			dropdown.classList.remove('active');
			}
		});
	}


	if(document.querySelector('.show-location-desktop')){
		let allOffers = document.querySelectorAll('.slider-offers__item');

		allOffers.forEach((offerSlide)=>{
			offerSlide.querySelector('.show-location-desktop').addEventListener('click',(e)=>{
				offerSlide.querySelector('.dropdown__location').classList.toggle('active');
			});
		})
	}

	window.addEventListener('resize', function () {
		topBookingWidget()
	});
	
	topBookingWidget()

	function topBookingWidget(){
		if(document.querySelector(".top-content") && window.innerWidth > 600){
			const topContent = document.querySelector(".top-content");
			let heightTopContent = topContent.offsetHeight;
			document.querySelector('#header .header__top').style.top = "calc("+ heightTopContent + "px - 150px)";
		}
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				document.getElementById('content').classList.add('down');
				document.getElementById('content').classList.remove('up');
				hiddenBookingWidget()
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				document.getElementById('content').classList.add('up');
				document.getElementById('content').classList.remove('down');
				hiddenBookingWidget()
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			document.getElementById('content').classList.remove('up');
			document.getElementById('content').classList.remove('down');
			document.querySelector('#header .header__top').classList.remove('show');
			showBookingWidget()
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function hiddenBookingWidget(){
	if(document.querySelector('#booking-widget-tpl')!=undefined){
		let booking = document.querySelector('#booking-widget-tpl');
		if(!booking.classList.contains('hidden'))booking.classList.add('hidden');
	}
}

function showBookingWidget(){
	if(document.querySelector('#booking-widget-tpl')!=undefined){
		let booking = document.querySelector('#booking-widget-tpl');
		if(booking.classList.contains('hidden'))booking.classList.remove('hidden');
	}
}

function validationLocationBothBookings(formSelector) {
	const form = document.querySelector(formSelector);
	const bookNowBtn = form.querySelector('.bookNow');
	const propertyTrigger = form.querySelector('.custom-select__trigger span');
	const errorMessage = form.querySelector('.select.property .msje-error');
	bookNowBtn.addEventListener('click', function(e) {
		if (propertyTrigger.textContent === 'Select Property') {
			e.preventDefault();
			errorMessage.classList.remove('hidden');
		} else {
			errorMessage.classList.add('hidden');
		}
	});
	const select = form.querySelector('.custom-select');
	select.querySelectorAll('.custom-select__options li:not(.custom-select__optgroup)').forEach(option => {
		option.addEventListener('click', function() {
			const value = this.getAttribute('data-value');
			const text = this.textContent;
			
			propertyTrigger.textContent = text;
			select.classList.remove('open');
			errorMessage.classList.add('hidden');
			
			if (form && value) {
				form.action = value;
			}
		});
	});
}